<template>
    <div class="spo-action-card pa-4 rounded" @click="actionOnClick">
        <v-icon class="icon-action" :icon="icon" color="primary-dark"></v-icon>
        <div class="text-h6">{{ title }} <v-icon class="chevron-link" icon="mdi-chevron-right"></v-icon></div>
        <div>{{ description }}</div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        toPage: {
            type: Object
        },
        toUrl: {
            type: String
        }
    },
    name: 'ActionCard',
    methods: {
        actionOnClick() {
            if (this.toPage) {
                this.$router.push(this.toPage);
                return;
            }
            if (this.toUrl && this.toUrl !== '') {
                window.open(this.toUrl, '_blank');
                return;
            }
            this.$emit('onClick');
        }
    }
}
</script>

<style lang="scss" scoped>
.spo-action-card {
    cursor: pointer;
    background-color: #f6f8fd;
    border: 1px solid #e9edf4;
    transition: all 0.3s ease;

    .chevron-link {
        transition: all 0.3s ease;
    }

    .icon-action {
        transition: all 0.3s ease;
    }

}

.spo-action-card:hover {
    box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;

    .chevron-link {
        transform: translateX(0.2rem);
    }

    .icon-action {
        color: #F29200 !important;
    }
}
</style>
